import React from 'react';
import classes from './PageSelection.css';

const pageSelection = (props) => (
        <div>
            <nav aria-label="Table pagination">
                <ul class="pagination">
                    <li class="page-item"><a class="page-link" onClick={props.previous}>Previous</a></li>
                    <li class="page-item disbaled-li"><a class="page-link">{props.value} / {props.numPages}</a></li>
                    <li class="page-item"><a class="page-link"onClick={props.next}>Next</a></li>
                </ul>
            </nav>
        </div>
);
export default pageSelection;